import { FTProcess } from '@/models/FTProcess';
import { weightToLength, initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { ConversionDetails } from '@/models/ConversionDetails';
import _ from 'lodash';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: 'layer',
          goodsFilter: {
            form: ['roll']
          },
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        },
        {
          goodsType: 'coating-material',
          // TODO: coating materials not available in goods array right now 
          // goodsFilter: {
          //   family: ['Coating']
          // },
          type: 'coating',
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Output Quantity',
          type: 'label',
          value: _.get(processRow, 'quantity', ''),
          unit: 'KG',
          disabled: true
        },
        {
          name: 'Coated Sides',
          type: 'dropdown',
          value: 'coatedSide',
          optionsArray: [ 'Front Side Only', 'Back Side Only', 'Both Sides' ],
          disabled: false
        },
        {
          name: 'Front Side',
          type: 'text',
          value: 'frontSideSpecs',
          group: 1,
          showIf: [ 'Front Side Only', 'Both Sides' ].includes(_.get(processRow, 'coatedSide')),
          disabled: false
        },
        {
          name: 'Back Side',
          type: 'text',
          value: 'backSideSpecs',
          group: 1,
          showIf: [ 'Front Side Only', 'Both Sides' ].includes(_.get(processRow, 'coatedSide')),
          disabled: false
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'Linear Length',
        value: 'linearMeters'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  const layerInputFTProcessRow = process.inputs[0];
  const coatingInputFTProcessRow = process.inputs[1];
  const outputFTProcessRow = process.outputs[0];

  const layerQuantity = layerInputFTProcessRow.quantity || 0;
  const coatingQuantity = coatingInputFTProcessRow.quantity || 0;
  const totalInputQuantity = layerQuantity + coatingQuantity;

  const layerDensity = layerInputFTProcessRow.goodsObject.density || 0;
  const coatingDensity = _.get(coatingInputFTProcessRow, 'goodsObject.density', 0);
  const totalInputDensity = layerDensity + coatingDensity;

  const layerInputWidth = _.get(layerInputFTProcessRow, 'goodsObject.dimensions.width', 0);
  outputFTProcessRow.goodsObject.copyFrom(layerInputFTProcessRow.goodsObject);
  outputFTProcessRow.quantity = totalInputQuantity;
  conversionResult.outputs[0] = outputFTProcessRow;
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.linearMeters = weightToLength(totalInputQuantity, totalInputDensity, layerInputWidth);
  conversionResult.details.netWeight = outputFTProcessRow.quantity;
  conversionResult.details.kgPerHour = 60 * (process.machineDetail.mechanicalSpeed / conversionResult.details.linearMeters) * outputFTProcessRow.quantity;
  conversionResult.details.plannedHours = conversionResult.details.linearMeters / (process.machineDetail.mechanicalSpeed * 60);

  return conversionResult;
}